import { inject, Injectable } from '@angular/core';
import { BackendDataSourceService } from '@ntap/core';
import { TreeNode } from 'primeng/api';
import { forkJoin, map, Observable, of } from 'rxjs';

@Injectable()
export class KlasifikacijskiSifrarnikService {
  backendDataSourceService = inject(BackendDataSourceService);
  dosjeAndPodrucjeArray$: Observable<TreeNode[]>;

  getKlasPodrucje() {
    return this.getKlasDosjeAndPodrucje(true);
  }

  getKlasDosjeAndPodrucje(isDosjeHidden?: boolean) {
    this.dosjeAndPodrucjeArray$ = forkJoin([
      this.backendDataSourceService.getViewData('seup.klas_plan_podrucje', {}),
      isDosjeHidden
        ? of([])
        : this.backendDataSourceService.getViewData('seup.klas_plan_dosje', {})
    ]).pipe(
      map(([podrucjeData, dosjeData]) => {
        const buildDosjeHierarchy = (
          parentId: number | null,
          podrucjeId?: number
        ): TreeNode[] => {
          return dosjeData
            .filter((dosje: any) =>
              parentId
                ? dosje['seup~klas_plan_dosje~parent_id'] == parentId
                : dosje['seup~klas_plan_dosje~podrucje_id'] == podrucjeId &&
                  !dosje['seup~klas_plan_dosje~parent_id']
            )
            .map((dosje: any) => ({
              label: `${dosje['seup~klas_plan_dosje~oznaka']} ${
                dosje['seup~klas_plan_dosje~naziv'] || ''
              }`,
              data: this.createTempKlasaForDosje(
                dosje['seup~klas_plan_dosje~id']
              ),
              children: buildDosjeHierarchy(dosje['seup~klas_plan_dosje~id'])
            }));
        };

        const buildPodrucjeHierarchy = (parentId: any): TreeNode[] => {
          return podrucjeData
            .filter(
              (podrucje: any) =>
                podrucje['seup~klas_plan_podrucje~grupa_id'] == parentId
            )
            .map((podrucje: any) => {
              const childrenPodrucja = buildPodrucjeHierarchy(
                podrucje['seup~klas_plan_podrucje~id']
              );

              const dosjeHierarchy = buildDosjeHierarchy(
                null,
                podrucje['seup~klas_plan_podrucje~id']
              );

              return {
                label: `${podrucje['seup~klas_plan_podrucje~vr_oznaka']} ${
                  podrucje['seup~klas_plan_podrucje~naziv'] || ''
                }`,
                data: `${podrucje['seup~klas_plan_podrucje~id']}`,
                children: [...childrenPodrucja, ...dosjeHierarchy]
              };
            });
        };

        // Build the hierarchy starting from the root (null parentId)
        const hierarchy = buildPodrucjeHierarchy(null);
        return hierarchy;
      })
    );
    return this.dosjeAndPodrucjeArray$;
  }

  createTempKlasaForDosje(dosjeId: number) {
    return `DOSJE-${dosjeId}`;
  }
}
